import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import UserPrefsContext from '../../../../context/UserPrefs/UserPrefsContext';
import Select from '../../../../components/shared/InputElements/Select';
import { useIntl } from 'react-intl';

const SelectPublicChargingCost = ({
  id = 'select-public-charging-cost',
  label,
  ...rest
}) => {
  const intl = useIntl();
  const userPrefs = useContext(UserPrefsContext);

  const options = [
    {
      id: 0,
      label: intl.formatMessage({ id: 'free', defaultMessage: 'Free' }),
    },
    {
      id: 25,
      label: intl.formatMessage({
        id: 'low',
        defaultMessage: 'SMUD public charging: $0.25/kWh',
      }),
    },
    {
      id: 50,
      label: intl.formatMessage({
        id: 'mid',
        defaultMessage: 'Other public charging: $0.50/kWh',
      }),
    },
    {
      id: 75,
      label: intl.formatMessage({
        id: 'midUp',
        defaultMessage: 'Other public charging: $0.75/kWh',
      }),
    },
    {
      id: 100,
      label: intl.formatMessage({
        id: 'high',
        defaultMessage: 'Other public charging: $1.00/kWh',
      }),
    },
  ];

  return (
    <Select
      id={id}
      value={userPrefs.get('publicChargingCostInCentsPerKwh')}
      label={
        intl.formatMessage
          ? intl.formatMessage({
              id: 'costOfPublicCharging',
              defaultMessage: 'Cost of public charging',
            })
          : 'Cost of public charging'
      }
      tooltip={intl.formatMessage({
        id: 'costOfPublicChargingTooltip',
        defaultMessage:
          "The price of charging at SMUD’s public chargers is $0.25/kWh. Other public charging in SMUD's territory varies.",
      })}
      optionNames={options.map((option) => option.label)}
      optionValues={options.map((option) => option.id)}
      handler={(e) =>
        userPrefs.set({ publicChargingCostInCentsPerKwh: e.target.value })
      }
      isLarge
      {...rest}
    />
  );
};

export default SelectPublicChargingCost;

SelectPublicChargingCost.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
};
